// extracted by mini-css-extract-plugin
export default {"cancel_button":"password_reset_authenticated_cancel_button__M2Dp8","complete_message":"password_reset_authenticated_complete_message__WQbZW"};